function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M32.5264 17.8146L20.3973 5.58278C20.0269 5.20927 19.5239 5 18.9998 5C18.4758 5 17.9728 5.20927 17.6024 5.58278L5.47467 17.8146C5.01105 18.2809 4.87314 18.9828 5.1227 19.5934C5.37356 20.2027 5.96327 20.6001 6.61866 20.6001H7.93073V31.5457C7.93204 32.3483 8.5769 32.9987 9.37283 33H28.6271C29.423 32.9987 30.0679 32.3484 30.0679 31.5457V20.6001H31.3813C32.0367 20.6001 32.6264 20.2027 32.8773 19.5934C33.1268 18.9828 32.9889 18.2809 32.5266 17.8146H32.5264ZM16.6962 31.7181V24.3181C16.6962 24.2055 16.7869 24.1154 16.8972 24.1141H21.1028C21.2132 24.1154 21.3038 24.2055 21.3038 24.3181V31.7181H16.6962ZM31.7018 19.1023C31.6505 19.236 31.5231 19.3221 31.3813 19.3182H30.0272C29.3482 19.3195 28.7979 19.8745 28.7965 20.5592V31.5458C28.7965 31.6412 28.7204 31.718 28.6271 31.718H22.575V24.318C22.5737 23.4981 21.9157 22.8332 21.1027 22.8319H16.8971C16.0841 22.8332 15.4261 23.4981 15.4248 24.318V31.718H9.37269C9.27944 31.718 9.20327 31.6412 9.20327 31.5458V20.5592C9.20195 19.8745 8.65163 19.3195 7.97262 19.3182H6.61852C6.47799 19.3182 6.35191 19.2334 6.29804 19.1023C6.24419 18.9725 6.27309 18.8215 6.37291 18.7221L18.502 6.49029C18.7804 6.22141 19.2191 6.22141 19.4975 6.49029L31.6266 18.7221C31.7291 18.8201 31.7593 18.9725 31.7015 19.1023H31.7018Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHus);
export default __webpack_public_path__ + "static/media/hus.635810a23a843cdc6b00532643b5f75a.svg";
export { ForwardRef as ReactComponent };